import { StandardProps } from "@/types/types";
import styles from "./Breadcrumbs.module.scss";
import { ESIInclude } from "@packages/esi-include/ESIInclude";
import { Breadcrumb } from "@/types/productListing";
import { useRouteParams, RouteParams } from "@/hooks/useRouteParams";
import { useFeatureFlags } from "@/flags/flags";
import classNames from "classnames/bind";

const cx = classNames.bind(styles);

export function Breadcrumbs({
  productListingData,
}: Pick<StandardProps, "productListingData">) {
  const { crumbs } = productListingData;
  const routeParams = useRouteParams();
  const featureFlags = useFeatureFlags();
  const isBreadcrumbsRightAlignOn =
    featureFlags?.isBreadcrumbsRightAlignOn?.value;

  let esiSource = getESISource(crumbs, routeParams);
  if (!esiSource) return null;
  esiSource = addMaxWidthParamToUrl(esiSource);

  const className = cx("breadcrumbs-carousel", {
    "breadcrumbs-carousel--rightAlign": isBreadcrumbsRightAlignOn,
  });

  return (
    <div className={className}>
      <ESIInclude src={esiSource} id="esiBreadcrumbs" />
    </div>
  );
}

export const getESISource = (
  breadcrumbs: Breadcrumb[],
  routeProps: RouteParams,
) => {
  const { query, pageType, facetId } = routeProps;

  const [lastBreadcrumb] = breadcrumbs.slice(-1);
  const { item, url } = lastBreadcrumb || {};

  if (!lastBreadcrumb) {
    return null;
  }

  const { "search-term": term, listHead } = query;

  if (pageType === "brand" && item) {
    return `/esi/breadcrumbs/brand/${encodeURIComponent(item)}`;
  }

  if (pageType === "browse") {
    const [nVal] = facetId && facetId.length > 0 ? facetId.slice(-1) : [];
    const cVal = url ? getNvalFromUrl(url) : "";

    if (cVal && cVal.startsWith("c")) {
      return `/esi/breadcrumbs/category/${cVal.substring(1)}`;
    } else if (nVal) {
      return `/esi/breadcrumbs/browse/${nVal}`;
    }
  }

  if (listHead) {
    return `/esi/breadcrumbs/search/${encodeURIComponent(listHead as string)}`;
  }

  return `/esi/breadcrumbs/search/${encodeURIComponent(term as string)}`;
};

export const getNvalFromUrl = (url: string) => {
  if (!url) return null;
  const lastSlash = url.lastIndexOf("/");
  return url.slice(lastSlash + 1);
};

const addMaxWidthParamToUrl = (url: string): string => {
  const separator = url.includes("?") ? "&" : "?";
  return `${url}${separator}isMaxWidth=true`;
};
